module.exports = __webpack_public_path__ + "img/cp2-1.f073742d.jpg";